import config from '../nyConfig'
const ApiManager = {
    /**
     * 菜单
     */

    "添加菜单": new config({url: '/manager/menu/addMenu', showSuccessMessage: true, useToken: true }),
    "修改菜单": new config({url: '/manager/menu/editMenu', showSuccessMessage: true, useToken: true }),
    "操作菜单": new config({url: '/manager/menu/operationMenu', showSuccessMessage: true, useToken: true }),
    "删除菜单": new config({url: '/manager/menu/delMenu', showSuccessMessage: true, useToken: true }),
    "菜单列表": new config({url: '/manager/menu/getMenu', showSuccessMessage: false, useToken: true }),

    /**
     * 角色
     */

    "添加角色": new config({url: '/manager/role/addRole', showSuccessMessage: true, useToken: true }),
    "修改角色": new config({url: '/manager/role/editRole', showSuccessMessage: true, useToken: true }),
    "操作角色": new config({url: '/manager/role/operationRole', showSuccessMessage: true, useToken: true }),
    "删除角色": new config({url: '/manager/role/delRole', showSuccessMessage: true, useToken: true }),
    "角色分页": new config({url: '/manager/role/pageRole', showSuccessMessage: false, useToken: true }),
    "角色列表": new config({url: '/manager/role/listRole', showSuccessMessage: false, useToken: true }),

    /**
     * 管理员
     */
    "添加管理员": new config({url: '/manager/user/addUser', showSuccessMessage: true, useToken: true }),
    "修改管理员": new config({url: '/manager/user/editUser', showSuccessMessage: true, useToken: true }),
    "操作管理员": new config({url: '/manager/user/operationUser', showSuccessMessage: true, useToken: true }),
    "删除管理员": new config({url: '/manager/user/delUser', showSuccessMessage: true, useToken: true }),
    "管理员分页": new config({url: '/manager/user/pageUser', showSuccessMessage: false, useToken: true }),
    "获得用户信息": new config({url: '/manager/user/getUserInfo', showSuccessMessage: false, useToken: true }),

    /**
     * 城市
     */
    "城市列表": new config({url: '/manager/city/cityTree', showSuccessMessage: false, useToken: true }),
    "城市子列表": new config({url: '/manager/city/listChild', showSuccessMessage: false, useToken: true }),
    "三级城市列表": new config({url: '/manager/city/jsonCityTree', showSuccessMessage: false, useToken: true }),
    "开通城市": new config({url: '/manager/city/toOpenCity', showSuccessMessage: true, useToken: true }),
    "冻结解冻城市": new config({url: '/manager/city/operationCity', showSuccessMessage: true, useToken: true }),
    "删除已开通城市": new config({url: '/manager/city/delOpenCity', showSuccessMessage: true, useToken: true }),
    "编辑二级域名": new config({url: '/manager/city/editSld', showSuccessMessage: true, useToken: true }),
    "编辑城市名称": new config({url: '/manager/city/editCityName', showSuccessMessage: true, useToken: true }),
    "添加详细地址": new config({url: '/manager/city/addAddressInfo', showSuccessMessage: true, useToken: true }),
    "修改详细地址": new config({url: '/manager/city/updateAddressInfo', showSuccessMessage: true, useToken: true }),
    "获得详细地址": new config({url: '/manager/city/getAddressInfo', showSuccessMessage: false, useToken: true }),

    /**
     * 系统设置
     */
    "添加系统设置": new config({url: '/manager/setting/addSetting', showSuccessMessage: true, useToken: true }),
    "编辑系统设置": new config({url: '/manager/setting/updateSetting', showSuccessMessage: true, useToken: true }),
    "系统设置分页": new config({url: '/manager/setting/pageSetting', showSuccessMessage: false, useToken: true }),


    /**
     * banner
     */
    "添加banner": new config({url: '/manager/banner/addBanner', showSuccessMessage: true, useToken: true }),
    "修改banner": new config({url: '/manager/banner/editBanner', showSuccessMessage: true, useToken: true }),
    "删除banner": new config({url: '/manager/banner/delBanner', showSuccessMessage: true, useToken: true }),
    "banner列表": new config({url: '/manager/banner/listBanner', showSuccessMessage: false, useToken: true }),

    "土地下拉列表": new config({url: '/land/selectList', showSuccessMessage: false, useToken: true }),
    "民宿下拉列表": new config({url: '/homestay/selectList', showSuccessMessage: false, useToken: true }),
    "招商下拉列表": new config({url: '/courtship/selectList', showSuccessMessage: false, useToken: true }),
    "需求下拉列表": new config({url: '/demand/selectList', showSuccessMessage: false, useToken: true }),

    /**
     * 用户、代理商 管理
     */
    "普通用户列表": new config({url: '/plate/user/manager/userList', showSuccessMessage: false, useToken: true }),
    "代理商用户列表": new config({url: '/plate/user/manager/agentUserList', showSuccessMessage: false, useToken: true }),
    "禁用启用用户":new config({url:'/plate/user/manager/operateUser', showSuccessMessage: true, useToken: true }),
    "审核代理商": new config({url: '/plate/user/manager/examineAgent', showSuccessMessage: true, useToken: true }),
    "政企用户列表": new config({url: '/plate/user/manager/governmentUserList', showSuccessMessage: false, useToken: true }),
    "添加政企用户": new config({url: '/plate/user/manager/addGovernmentUser', showSuccessMessage: true, useToken: true }),
    "编辑政企用户": new config({url: '/plate/user/manager/editGovernmentUser', showSuccessMessage: true, useToken: true }),

    /**
     * 关于我们
     */
    "关于我们列表": new config({url: '/manager/about/list', showSuccessMessage: false, useToken: true }),
    "关于我们编辑": new config({url: '/manager/about/edit', showSuccessMessage: true, useToken: true }),
    "关于我们删除": new config({url: '/manager/about/del', showSuccessMessage: true, useToken: true }),
    "关于我们状态": new config({url: '/manager/about/change', showSuccessMessage: true, useToken: true }),
    /**
     * 版本管理
     */
    "上传版本": new config({url: '/manager/version/add', showSuccessMessage: true, useToken: true }),
    "版本列表": new config({url: '/manager/version/list', showSuccessMessage: false, useToken: true }),
    "最新版本": new config({url: '/manager/version/latest', showSuccessMessage: false, useToken: true }),

    /**
     * 提示文本
     */
    "提示列表": new config({url: '/manager/tips/getList', showSuccessMessage: false, useToken: true }),
    "提示编辑": new config({url: '/manager/tips/edit', showSuccessMessage: true, useToken: true }),

    /**
     * 搜索推荐
     */
    "推荐列表": new config({url: '/manager/searchSuggest/list', showSuccessMessage: false, useToken: true }),
    "推荐编辑": new config({url: '/manager/searchSuggest/save', showSuccessMessage: true, useToken: true }),
    "推荐删除": new config({url: '/manager/searchSuggest/del', showSuccessMessage: true, useToken: true }),

    /**
     * 友情链接
     */
    "链接列表": new config({url: '/manager/links/list', showSuccessMessage: false, useToken: true }),
    "链接编辑": new config({url: '/manager/links/edit', showSuccessMessage: true, useToken: true }),
    "链接删除": new config({url: '/manager/links/del', showSuccessMessage: true, useToken: true })
}

export default ApiManager
